var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 291.914,
    height: 42.138,
    viewBox: "0 0 291.914 42.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7079",
    "data-name": "Group 7079",
    transform: "translate(-155.183 -58.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M967.472,182.4l-.487-.69a12.979,12.979,0,0,0,5.685-4.731,14.282,14.282,0,0,0,1.953-4.556,7.6,7.6,0,0,0,.148-2.737,11.142,11.142,0,0,0-.794-2.614,13.348,13.348,0,0,0-5.944-6.772,18.352,18.352,0,0,0-6.442-2.117,25.541,25.541,0,0,0-3.666-.254h-9.553v41.179h5.287V183.719h4.266a26.16,26.16,0,0,0,4.016-.307l.3.424,10.726,15.276h6.288L967.472,182.4m-9.186-3.2h-4.629l0-16.218h4.627a15.5,15.5,0,0,1,6.962,1.39,8.578,8.578,0,0,1,4.005,4.12,6.083,6.083,0,0,1,.59,2.9,6.368,6.368,0,0,1-.59,2.3,8.574,8.574,0,0,1-4.005,4.12,15.49,15.49,0,0,1-6.962,1.39",
    transform: "translate(-749.599 -98.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1015.2,188.214a14.876,14.876,0,0,1-12.8,6.509c-9.076,0-15.662-6.81-15.662-16.2s6.586-16.2,15.662-16.2c5.253,0,9.61,2.164,12.269,6.092l.3.443,4.081-2.97-.274-.412c-3.5-5.25-9.164-8.027-16.377-8.027a21.069,21.069,0,1,0,0,42.138c7.205,0,13.229-3.016,16.963-8.494l.289-.423-4.153-2.893Z",
    transform: "translate(-749.599 -98.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1052.187,180.55h-20.461V157.932h-5.286v41.192h5.286V185.483h20.461v13.641h5.287V157.932h-5.287Z",
    transform: "translate(-749.599 -98.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 5.346,
    height: 41.192,
    transform: "translate(318 59.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M1110.236,185.555c0,.8.062,1.827.13,2.707-.533-.726-1.169-1.574-1.7-2.214l-24.131-28.529h-1.466v41.606h5.05V171.5c0-.785-.071-1.786-.15-2.655.524.716,1.141,1.535,1.655,2.158l23.981,28.351.155.184h1.465v-41.6h-4.991Z",
    transform: "translate(-749.599 -98.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M1152,159.374l.079-.126v-1.315h-26.9v4.814h18.834l-21.943,34.935-.08.126v1.316h30.208V194.31h-22.082Z",
    transform: "translate(-749.599 -98.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1190.856,199.112h5.84q-4.725-10.215-9.421-20.4-4.761-10.32-9.534-20.649c-.588,1.357-1.251,2.726-1.9,4.056-.427.882-.853,1.761-1.256,2.634l-15.928,34.362h5.9l2.245-4.861h21.8Zm-21.565-10.238,8.416-18.219,8.418,18.219Z",
    transform: "translate(-749.599 -98.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M937.034,199.084l-13.173-28.507-8.767,19.111a14.788,14.788,0,0,0,4.184,2.531,13.3,13.3,0,0,0,4.354.588l-2.313-4.986,2.887-6.293,4.037,8.779,2.614,5.7a18.535,18.535,0,0,1-6.091,1.341l-.138.007c-.253.012-.506.025-.762.025a19.867,19.867,0,0,1-9.62-2.538l-1.282-.725-2.271,4.967h-5.911s18.525-39.765,19.113-41.125c3.192,6.9,15.834,34.3,18.989,41.125Z",
    transform: "translate(-749.599 -98.69)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white-logo.3589471e540aaeb342d2785e9457bc26.svg";
export { ForwardRef as ReactComponent };